module.exports = __webpack_public_path__ + "static/media/richtig2.6797f741.jpg";